<template>
  <div class="news-notify" v-if="!hasAcceptedNews">
    <router-link to="/news" exact-active-class="active" class="news-notify--button">
      <span class="icon icon--info"> <i class="news"></i></span>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['hasAcceptedNews'])
  }
};
</script>

<style lang="scss" scoped>
.news-notify {
  display: flex;
}

.icon {
  display: flex;

  &:before {
    content: '';
    display: inline-block;
    height: 20px;
    width: 20px;
    transition: background 0.25s ease-out;
  }

  &--info {
    &:before {
      background: url('../../assets/img/icon-info-active.svg') no-repeat center center;
    }
  }
}
</style>
